import api from 'api'
import { CACHE_TAG_BILLING_PAYMENT_GROUP_LIST } from '../../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    createPaymentGroup: build.mutation({
      query: body => ({ url: '/api/v1/billing/payment/groups', method: 'POST', body }),
      invalidatesTags: [CACHE_TAG_BILLING_PAYMENT_GROUP_LIST],
    }),
  }),
})

export const { useCreatePaymentGroupMutation } = extendedApi
